import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  nickname: '',
  email: '',
  id: '',
  gener: 'u',
  first_name: '',
  last_name: '',
  phone: '',
  country: '',
  state: '',
  address: '',
  zip_code: '',
  data_of_birth: '',
  date_joined: '',
  last_login: '',
  university: '',
  picture: '',
  has_accepted_toc: true,
  has_accepted_survey: false,
  type: '',
  teams: null,
  admins: null,
  token: '',
  title: '',
  education: '',
  cover_picture: '',
  about_me: ''
};

const userSlice = createSlice({
  name: 'auth/user',
  initialState,
  reducers: {
    setUser(state, action) {
      // Merge all fields from payload into state
      Object.assign(state, action.payload);
    },
    // eslint-disable-next-line no-param-reassign
    updateUniversity(state, action) {
      // Merge updated university fields into the embedded university object
      // so consumers (BrandingProvider, settings pages) react without a
      // full /me refetch after admin-side PATCHes.
      if (!action.payload) return;
      if (state.university && typeof state.university === 'object') {
        Object.assign(state.university, action.payload);
      } else {
        // eslint-disable-next-line no-param-reassign
        state.university = action.payload;
      }
    }
  }
});

export const { setUser, updateUniversity } = userSlice.actions;
export default userSlice.reducer;
